/* CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
import React, {
  Component,
  PropTypes
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AudioManager from '../utils/AudioManager';
import { Channels, channelsOfType, ChannelTypes } from '../data/channels';
import { StreamManager } from '../utils/Streams';
import _ from 'lodash';
import fp from 'lodash/fp';
import { roundToNearestThree } from '../utils/Channels';
import CypherComponent from '../components/CypherComponent';
require('styles/App.css');
require('vendor/pure/grids.css');

const cyphers = [
  require('../images/cypher1.png'),
  require('../images/cypher2.png'),
  require('../images/cypher3.png'),
  require('../images/cypher4.png'),
  require('../images/cypher5.png'),
  require('../images/cypher6.png')
];

/* Populated by react-webpack-redux:reducer */
class App extends Component {
  constructor(props) {
    super(props);

    window.TheNetwork = window.TheNetwork || {};
    window.TheNetwork.audioManager = window.TheNetwork.audioManager ||
      new AudioManager;
    window.TheNetwork.streamManager = window.TheNetwork.streamManager ||
      new StreamManager;
    this.audioManager = window.TheNetwork.audioManager;
    this.streamManager = window.TheNetwork.streamManager;
    this.transitionToChannel(props);
    this.state = {
      channelFilter: false,
      showChannelList: false,
      invert: false,
      universalExpansion: 0,
      showExpansion: false,
      showLightBox: false
    };
    this.lastTime = new Date();
  }

  getChannelData(channel) {
    if (_.isString(channel)) {
      channel = parseInt(channel);
    }
    if (_.isUndefined(Channels[channel])) {
      channel = roundToNearestThree(channel % 333);
    }
    return Channels[channel.toString()];
  }

  getChannel(channel) {
    channel = parseInt(channel);
    let channelData = this.getChannelData(channel);

    let channelList = this.state.channelFilter === false ?
      Channels :
      channelsOfType(this.state.channelFilter);

    if (!this.state.showChannelList) {
      channelList = false;
    }

    const globalProps = {
      audioManager: this.audioManager,
      streamManager: this.streamManager,
      channelList
    };
    const props = fp.flow(
      fp.omit(['layout']),
      fp.merge(globalProps)
    )(channelData);
    const Layout = channelData.layout;

    return <Layout {...props} />;
  }

  transitionToChannel(props) {
    // for smooth transitions w/o re-renders
    const channel = this.getChannelData(props.params.channel || 0);
    if (_.isUndefined(channel)) {
      return;
    }

    this.streamManager.makeChannelStreams(channel);

    if (channel.channel % 333 !== 0 || channel.channel === 0) {
      this.audioManager.transitionFromURL(channel.track);
    } else {
      this.audioManager.transitionFromURL('');
    }
  }

  componentWillReceiveProps(nextProps) {
    this.transitionToChannel(nextProps);
  }

  render() {
    const channel = this.props.params.channel || 0;
    const clickFor = (i) => {
      return {
        0: () => {
          this.setState({
            channelFilter: false,
            showChannelList: true
          });
        },
        1: () => {
          if (this.expansionInterval) {
            clearInterval(this.expansionInterval);
            this.expansionInterval = false;
            this.setState({showExpansion: false});
          } else {
            this.expansionInterval = setInterval(() => {
              this.setState((state) => {
                const now = new Date();
                const increment = Math.floor(
                  (now.getTime() - this.lastTime.getTime()) * 0.064
                );
                this.lastTime = now;

                return {
                  universalExpansion: state.universalExpansion + increment,
                  showExpansion: true
                };
              });
            }, 100);
          }
        },
        2: () => {
          this.audioManager.toggleMute();
        },
        3: () => {
          this.setState({
            channelFilter: ChannelTypes.NON_MUSIC,
            showChannelList: true
          });
        },
        4: () => {
          this.setState({
            channelFilter: ChannelTypes.MUSIC,
            showChannelList: true
          });
        },
        5: '#/about'
      }[i];
    };

    const containerStyle = this.state.invert ?
      {filter: 'invert(100%)', WebkitFilter: 'invert(100%)'} :
      {};

    const cypherButtons = _.map(cyphers, (img, i) => {
      return <CypherComponent key={i}
                              image={img}
                              click={clickFor(i)} />;
    });

    const expansionClasses = 'expansion-counter' +
      (this.state.showExpansion ? ' show' : '');

    return (
      <div className="container" style={containerStyle}>
        <div className="top-bar">
          {cypherButtons}
        </div>
        <div className="main-table">
          <div className="pure-g">
            <div className={expansionClasses}>
              <p>{this.state.universalExpansion}</p>
              <p className="label">UE (KM)</p>
            </div>
            {this.getChannel(channel)}
          </div>
        </div>
      </div>

    );
  }
}

/* Populated by react-webpack-redux:reducer
 *
 * HINT: if you adjust the initial type of your reducer, you will also have to
 *       adjust it here.
 */
App.propTypes = {
  actions: PropTypes.object.isRequired,
  channels: PropTypes.object.isRequired,
  params: PropTypes.object
};

function mapStateToProps(state) {
  /* Populated by react-webpack-redux:reducer */
  const props = { channels: state.channels };
  return props;
}
function mapDispatchToProps(dispatch) {
  /* Populated by react-webpack-redux:action */
  const actions = {
    update_channel: require('../actions/channels/update_channel.js')
  };
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js